"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DocumentUserIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "32",
  height: "38",
  viewBox: "0 0 32 38",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "prefix__commissionagent__a",
      d: "M0 .82h31.05V38H0z"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15.858 15.231c-1.241 0-2.252 1.189-2.252 2.65 0 1.46 1.01 2.648 2.252 2.648 1.242 0 2.252-1.188 2.252-2.648 0-1.461-1.01-2.65-2.252-2.65m0 6.866c-2.13 0-3.861-1.891-3.861-4.216 0-2.326 1.732-4.217 3.86-4.217 2.13 0 3.862 1.891 3.862 4.217 0 2.325-1.732 4.216-3.861 4.216M10.657 29.938h10.268l.206-2.967c.044-.61-.535-1.57-1.32-1.853a12.33 12.33 0 00-8.047.002c-.776.28-1.356 1.243-1.314 1.851l.207 2.967zm11.02 1.568H9.906a.796.796 0 01-.803-.73l-.259-3.7c-.094-1.362.992-2.931 2.37-3.429a13.94 13.94 0 019.146-.002c1.39.499 2.476 2.07 2.377 3.433l-.258 3.697a.796.796 0 01-.802.73z",
      fill: "#4DAA50",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.19 1.17c.467 0 .847.368.847.825v9.902c0 .456-.38.825-.847.825H2.027a.835.835 0 01-.847-.825c0-.457.378-.826.847-.826h9.315V1.995c0-.457.378-.826.848-.826",
      fill: "#FFF",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(.333 -.476)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
        id: "prefix__commissionagent__b",
        fill: "#fff",
        className: "svg-fill-secondary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#prefix__commissionagent__a"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M27.662 4.121H12.557l-9.17 8.935V34.7h24.275V4.121zM11.856.821h17.5c.936 0 1.694.737 1.694 1.65V36.35c0 .913-.758 1.651-1.694 1.651H1.694C.757 38 0 37.262 0 36.35V12.372c0-.439.178-.858.495-1.167l10.163-9.902c.318-.31.748-.484 1.198-.484z",
        fill: "#FFF",
        mask: "url(#prefix__commissionagent__b)",
        className: "svg-fill-secondary"
      })]
    })]
  })]
});

DocumentUserIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(DocumentUserIcon);

exports.default = _default;